<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<div class="image_container">
<img alt="image" src="images/fig1.jpg"/>
<p class="caption">A letter, allegedly by Sidney Reilly, ‘the ace of spies’, from the internal Lubyanka prison dated 30 October 1925 and addressed to the OGPU chairman Felix Dzerzhinsky. In this letter or note, originally written in Russian, Reilly gives his explicit agreement to disclose information about British and American secret services, their structure and staff, as well as about his contacts among the Russian émigré community.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM02.vue?7c207c2b